import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface UndoDeleteShapeRequest {
  shapeId: string;
}

export interface UndoDeleteShapeResponse {
  ok: true;
}

export function useUndoDeleteShape() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UndoDeleteShapeRequest) {
    const shapeId = action.shapeId;
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`shape/${shapeId}/undo-delete`), {
      headers,
      method: 'PUT'
    });

    const text = translations.value.shapes.actions.undoDelete;

    const response = await httpClient.action<UndoDeleteShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk() {
        return {
          ok: true
        };
      },
    });

    return response;
  }
}
